import * as preloader from '../libs/preloader'

/**
 * lazy load
 */

export const load = (el, src) => {
  preloader.load(src).then(() => {
    el.querySelector('img').setAttribute('src', src)
    setTimeout(() => {
      el.classList.add('is-loaded')
    }, 500)
  })
}



// WEBPACK FOOTER //
// ./src/script/libs/lazy-load.js